import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const UserProfileWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full p-6" data-id="element-630">
      <div className="flex flex-col h-full" data-id="element-631">
        <div className="flex items-center mb-4" data-id="element-632">
          <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-custom-green flex-shrink-0" data-id="element-633">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg" alt="Edoardo Gatner" className="w-full h-full object-cover" data-id="element-634" />
          </div>
          <div className="ml-4" data-id="element-635">
            <h3 className="text-base font-semibold text-gray-800" data-id="element-636">
              Edoardo Gatner
            </h3>
            <p className="text-sm text-gray-500" data-id="element-637">CEO</p>
            <p className="text-sm text-gray-500" data-id="element-638">Milano, Italia</p>
          </div>
        </div>
        <div className="text-sm text-gray-600 mb-4" data-id="element-639">
          Esperto di leadership aziendale con focus su sostenibilità e strategie
          ESG per imprese orientate al futuro.
        </div>
        <div className="flex flex-wrap gap-2 mb-6" data-id="element-640">
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-641">
            ESG
          </span>
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-642">
            Sostenibilità
          </span>
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-643">
            Green Finance
          </span>
        </div>
        <div className="mt-auto" data-id="element-644">
          <Link to="/public-profile" className="w-full flex items-center justify-center py-2 bg-custom-green text-white rounded-lg transition-colors hover:bg-custom-green/90" data-id="element-645">
            <ExternalLinkIcon size={16} className="mr-2" data-id="element-646" />
            Profilo Pubblico
          </Link>
        </div>
      </div>
    </div>;
};
export default UserProfileWidget;